function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "116",
  height: "96"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fb70708b-9235-4ce5-b7b0-5df5377144a2",
  "data-name": "New Gradient Swatch 5",
  x1: "25",
  y1: "15",
  x2: "110.41",
  y2: "100.41",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ab27ab33-865f-44bb-a397-eb42ca0a2b2a",
  x1: "87.06",
  y1: "46.47",
  x2: "108.06",
  y2: "46.47",
  xlinkHref: "#fb70708b-9235-4ce5-b7b0-5df5377144a2"
})), /*#__PURE__*/React.createElement("title", null, "graphic_spot_video-edit"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "bd896cae-7857-48d4-b041-4171bce5e502",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M114 16H27.49L36 24.51V21a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1h-7.51l28.38 28.38L70 61.81 73.31 70a1.21 1.21 0 01-1.52 1.52l-13.66-5.39L16 24v70a2 2 0 002 2h96a2 2 0 002-2V18a2 2 0 00-2-2zm-30 5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H85a1 1 0 01-1-1zm-16 0a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H69a1 1 0 01-1-1zm-16 0a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1H53a1 1 0 01-1-1zM32 91a1 1 0 01-1 1H21a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H37a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H53a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H69a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1H85a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm16 0a1 1 0 01-1 1h-10a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1zm0-64a1 1 0 01-1 1h-10a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1z",
  fill: "url(#fb70708b-9235-4ce5-b7b0-5df5377144a2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112 33v46a1 1 0 01-1 1H21a1 1 0 01-1-1V33a1 1 0 011-1h3l34.13 34.13 13.66 5.43A1.21 1.21 0 0073.31 70L70 61.81l-2.16-5.43L43.49 32H111a1 1 0 011 1z",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".2",
  fill: "#193138"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112 66.76V79a1 1 0 01-1 1H21a1 1 0 01-1-1V66.76C31.34 58 40.72 56.13 47.06 56H48l10.13 10.13 13.66 5.43A1.21 1.21 0 0073.31 70L70 61.81c12.51 5.91 23.31 13.6 35 9.16a22.85 22.85 0 007-4.21z",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".1",
  fill: "#193138"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "97.56",
  cy: "46.47",
  r: "10.5",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "url(#ab27ab33-865f-44bb-a397-eb42ca0a2b2a)",
  opacity: ".2"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#7ca5cc"
}, /*#__PURE__*/React.createElement("path", {
  d: "M67.87 56.38L73.31 70a1.21 1.21 0 01-1.52 1.52l-13.66-5.39L3 11a2.17 2.17 0 01.21-3l6.5-6.49a2.16 2.16 0 013-.21z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: ".2",
  d: "M19.51 8.02l-9.75 9.74 48.37 48.37 4.84-4.85 4.9-4.9L19.51 8.02z"
})))));